export const AUTHORITY_PROFILE_TYPE = 'AuthorityProfile'
export const BLOG_PROFILE_TYPE = 'BlogProfile'
export const INTERMEDIATE_PROFILE_TYPE = 'IntermediateProfile'
export const NO_USER_PROFILE_TYPE = 'no_user_profile'
export const PRESS_PROFILE_TYPE = 'PressProfile'
export const PRIVATE_PROFILE_TYPE = 'PrivateProfile'
export const REPORTER_PROFILE_TYPE = 'ReporterProfile'
export const ADMIN_PROFILE_TYPE = 'super_admin'
